import { gql } from '@apollo/client';

export const FETCH_QUOTES = gql`
  query fetchEpigrafi($where: EpigrafiWhereInput) {
    epigrafis(where: $where, first: 500, order: createdAt_ASC) {
      edges {
        node {
          objectId
          org_pointer {
            objectId
          }
          testo
          category
        }
      }
    }
  }
`;

export const CREATE_QUOTE = gql`
  mutation createEpigrafi($fields: CreateEpigrafiFieldsInput) {
    createEpigrafi(input: { fields: $fields }) {
      epigrafi {
        objectId
        testo
        category
      }
    }
  }
`;

export const DELETE_QUOTE = gql`
  mutation DeleteEpigrafi($id: ID!) {
    deleteEpigrafi(input: { id: $id }) {
      epigrafi {
        objectId
      }
    }
  }
`;
